import { inject, Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { MultisiteService } from '@df/core/service/multisite';
import { Url } from '@df/core/service/url';
import { Status } from '@df/core/status';

@Injectable({
    providedIn: 'root'
})
export class SsrApiService {
    private requestService = inject(RequestService);
    private multisiteService = inject(MultisiteService);

    flushUniversalCache(status: Status | undefined) {
        return this.requestService.send(
            status,
            {
                path: `ci/universal`
            },
            undefined,
            undefined,
            {
                api: 'ssr',
                method: 'GET'
            }
        );
    }

    flushByTag(
        status: Status | undefined,
        request: {
            type: string;
            ids: (string | number)[];
            flush: boolean;
        }
    ) {
        return this.requestService.send(
            status,
            {
                path: `ci/model`,
                data: {
                    ...request,
                    site: this.multisiteService.current.siteId
                }
            },
            undefined,
            undefined,
            {
                api: 'ssr',
                method: 'POST'
            }
        );
    }
}
